import { AppBar,Toolbar, Typography, Box } from "@mui/material";
import logo from './logo.png';

const Header = () => {
    return(
        <AppBar position="static">
            <Toolbar>
                <Box component="img" src={logo} alt="logo" sx={{width:180, height: 45}} />
                <Typography variant="h6" component="div" sx={{flexGrow: 1, textAlign: "left"}}>
                    Credential Validation
                </Typography>
                <Box component="img" src={logo} alt="logo" sx={{width:140, height: 35}} />
            </Toolbar>
        </AppBar>
    );
}

export default Header;